import {sendCustomMetric} from '@github-ui/stats'
import {on} from 'delegated-events'

const submittedConfirmationForms = new WeakSet<HTMLFormElement>()

on('click', '[data-show-dialog-id$="-features-default-off-confirmation"]', event => {
  const dialogId = event.currentTarget.getAttribute('data-show-dialog-id')
  const dialog = dialogId ? document.getElementById(dialogId) : null
  if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return

  const form = dialog.closest(
    '.js-copilot-feature-default-off-confirmation-form[data-feature-default-off-confirmation-enabled="true"]',
  )
  if (!form) return

  sendCustomMetric({name: 'COPILOT_FEATURES_DEFAULT_OFF_CONFIRMATION', value: 1, tags: {action: 'shown'}}, false, 1)
})

on(
  'submit',
  '.js-copilot-feature-default-off-confirmation-form[data-feature-default-off-confirmation-enabled="true"]',
  event => {
    const form = event.currentTarget as HTMLFormElement
    if (submittedConfirmationForms.has(form)) {
      event.preventDefault()
      return
    }
    submittedConfirmationForms.add(form)
    sendCustomMetric(
      {name: 'COPILOT_FEATURES_DEFAULT_OFF_CONFIRMATION', value: 1, tags: {action: 'confirmed'}},
      true,
      1,
    )
  },
  {capture: true},
)

on('click', '[data-show-dialog-id$="-models-default-off-confirmation"]', event => {
  const trigger = event.currentTarget as HTMLElement
  const dialogId = trigger.getAttribute('data-show-dialog-id')
  if (!dialogId) return

  const dialog = document.getElementById(dialogId)
  if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return

  const form = dialog.closest<HTMLFormElement>('.js-copilot-model-default-off-confirmation-form')
  const confirmationContainer = form?.closest<HTMLElement>('[data-model-default-off-confirmation-enabled]')
  if (confirmationContainer?.getAttribute('data-model-default-off-confirmation-enabled') !== 'true') return

  sendCustomMetric({name: 'COPILOT_MODELS_DEFAULT_OFF_CONFIRMATION', value: 1, tags: {action: 'shown'}}, false, 1)
})

on(
  'submit',
  '.js-copilot-model-default-off-confirmation-form',
  event => {
    const form = event.currentTarget as HTMLFormElement
    const confirmationContainer = form.closest<HTMLElement>('[data-model-default-off-confirmation-enabled]')

    if (confirmationContainer?.getAttribute('data-model-default-off-confirmation-enabled') !== 'true') return

    if (submittedConfirmationForms.has(form)) {
      event.preventDefault()
      return
    }

    submittedConfirmationForms.add(form)
    // Flush now: the form submits with a full-page navigation, so a queued stat could be lost.
    sendCustomMetric({name: 'COPILOT_MODELS_DEFAULT_OFF_CONFIRMATION', value: 1, tags: {action: 'confirmed'}}, true, 1)
  },
  {capture: true},
)
